import React, { useState } from "react";
import Select from "react-select";

import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
import InputMask from "react-input-mask";
import { toastr } from "react-redux-toastr";

const DEVICE_TYPE_OPTIONS = ["email", "sms", "voice"];

const WhitelistModal = ({ isOpen, selected, toggleModal, applyChanges }) => {
  const [whitelistRecord, setWhitelistRecord] = useState({
    description_vch: "",
    contact_vch: "",
    channel_vch: DEVICE_TYPE_OPTIONS.length === 1 ? DEVICE_TYPE_OPTIONS[0] : null,
    ...selected,
  });

  const closeBtn = (
    <button type="button" className="close" onClick={toggleModal}>
      &times;
    </button>
  );

  function updateWhitelistRecord({ name, value }) {
    // console.log("Updating", name, "to", value);

    if (/description/.test(name)) {
      value = value.replace(/[^a-z-'.\s]/i, "");
    }

    setWhitelistRecord({
      ...whitelistRecord,
      [name]: value,
    });
  }

  function validateChanges(e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    if (!whitelistRecord.description_vch) {
      return toastr.error("Oops", "Please specify the contact's name");
    }

    if (!whitelistRecord.channel_vch) {
      if (whitelistRecord.channel_vch.value) {
        whitelistRecord.channel_vch = whitelistRecord.channel_vch.value;
      }
      return toastr.error("Oops", "Please specify the contact's channel");
    }
    if (!whitelistRecord.contact_vch) {
      return toastr.error("Oops", "Please specify the contact information");
    }

    // Copy without reference
    const record = {
      ...whitelistRecord,
    };

    if (record.channel_vch !== "email") {
      record.contact_vch = record.contact_vch.replace(/[^\d]/g, "");
    }

    applyChanges(record).then((success) => {
      success && toggleModal(false);
    });
  }

  return (
    <Modal isOpen={isOpen} toggle={toggleModal}>
      <form onSubmit={validateChanges} action="#">
        <ModalHeader toggle={toggleModal} close={closeBtn}>
          {whitelistRecord.created_at ? "Edit" : "Create"} Whitelist Record
        </ModalHeader>

        <ModalBody>
          <Row>
            <Col md={6} className="mb-4">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Name</InputGroupText>
                </InputGroupAddon>

                <Input
                  bsSize="lg"
                  type="text"
                  name="description_vch"
                  value={whitelistRecord["description_vch"] || ""}
                  onChange={({ target }) => updateWhitelistRecord(target)}
                  placeholder="Contact Name"
                  required={true}
                />
              </InputGroup>
            </Col>

            <Col md={6} className="mb-4">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Device Type</InputGroupText>
                </InputGroupAddon>

                {DEVICE_TYPE_OPTIONS.length === 1 ? (
                  <Input
                    bsSize="lg"
                    type="text"
                    name="channel_vch"
                    value={whitelistRecord["channel_vch"] || ""}
                    required={true}
                    disabled={true}
                    readOnly={true}
                  />
                ) : (
                  <Select
                    className="flex-fill"
                    value={
                      whitelistRecord["channel_vch"]
                        ? {
                            label: whitelistRecord["channel_vch"],
                            value: whitelistRecord["channel_vch"],
                          }
                        : ""
                    }
                    options={DEVICE_TYPE_OPTIONS.map((type) => ({ label: type, value: type }))}
                    onChange={({ value }) => updateWhitelistRecord({ name: "channel_vch", value })}
                    placeholder={DEVICE_TYPE_OPTIONS.join(", ")}
                  />
                )}
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col className="mb-4">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Device</InputGroupText>
                </InputGroupAddon>

                {!whitelistRecord["channel_vch"] || whitelistRecord["channel_vch"] === "email" ? (
                  <Input
                    bsSize="lg"
                    type="text"
                    name="contact_vch"
                    value={whitelistRecord["contact_vch"] || ""}
                    onChange={({ target }) => updateWhitelistRecord(target)}
                    placeholder={
                      whitelistRecord["channel_vch"]
                        ? "sample@email.com"
                        : "Please select a device type"
                    }
                    required={true}
                    disabled={!whitelistRecord["channel_vch"]}
                  />
                ) : (
                  <InputMask
                    mask="+1 (999) 999-9999"
                    maskChar={null}
                    value={whitelistRecord["contact_vch"] || ""}
                    onChange={({ target }) => updateWhitelistRecord(target)}
                  >
                    {(inputProps) => (
                      <Input
                        bsSize="lg"
                        name="contact_vch"
                        placeholder="+1 (123) 456-7890"
                        {...inputProps}
                      />
                    )}
                  </InputMask>
                )}
              </InputGroup>
            </Col>
          </Row>
        </ModalBody>

        <ModalFooter className="d-flex justify-content-between">
          <Button type="button" color="secondary" onClick={toggleModal}>
            Cancel
          </Button>

          <Button type="submit" color="primary" onClick={validateChanges}>
            Save
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default WhitelistModal;
